<template>

    <div>
        <div class="pesquisa-interno">
            <div style="float: left; width: 80%;"><input type="text" v-model="textoPesquisarModel" class="input-pesquisa"/></div>
            <div style="float: left; width: 20%;"><button class="botao-pesquisa-com-input" @click="pesquisar"><i class="fas fa-search fa-lg"></i></button></div>
        </div>
    </div>
</template>


<script>



export default {
    name: 'InputPesquisa',
    methods : {
        pesquisar(){
            this.$emit('pesquisar', this.textoPesquisarModel);
        }
	},

	beforeMount(){
		this.textoPesquisarModel = this.textoPesquisar;
	},
	props : ['textoPesquisar'],

    data() {
        return {
            textoPesquisarModel : ''
        }        
    }   
}
</script>

<style scoped>

	.input-pesquisa:focus, .botao-pesquisa:focus{
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);	
		transition: all  0.2s ease-in-out;
		outline: none;
		border: 1px solid #428bca;
	}
	
	.input-pesquisa{
		font-size: 18px;
		border-radius: 10px 0 0 10px;
		border: 1px solid #dedede;
		
		padding: 10px;
		width: calc(100% - 22px);	
		transition: all  0.2s ease-in-out;	
		height: 26px;	
	
	}
	
	.botao-pesquisa-com-input{
		font-size: 18px;
		border-radius: 0 10px 10px 0;
		
		background-color: var(--primary-color);
		border: 0px;		
		
		transition: all  0.2s ease-in-out;		
		
		padding: 5px;
		width: 100%;
		color: #FFFFFF;
		height: 48px;
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
    
    .pesquisa-interno{
        width: 96%;
        --margin: 20px 2%;
        padding: 15px 2%;
        height: 50px;
        background-color:var(--light-color);
    }

</style>
